<template>
    <div>
        <gofix-default-table :settings="tableConfig"
            :table-items="tableItems"
            @delete-items="deleteItems"
            @create-pwo="createPWO"
            @disable-items="disableItem"
            @assign-items="assignItems"
            @edit-status-items="editStatusItem"
            @load-items="getTableData"
            @export="exportItems"
            @change-selected="getJobItems"
            @period-filter="(tableRequest) => {
                this.modals.period.tableRequest = tableRequest;
                this.modals.period.start_date = null;
                this.modals.period.end_date = null;
                this.modals.period.open = true;
             }"
             @btn-reschedule="btnReschedule"
             ref="gofixTable">
             <template slot="gofix_table:after-control-left">
                <template v-if="isShowRescheduledButton">
                    <gofix-button id="gofix-button-mass" class="ml-2" label="Reschedule" outline></gofix-button>  
                </template>
            </template>
            <template slot="gofix_table:order_number" slot-scope="data">
                <span @click="gotoOrderNumber(data.item)" class="checklistLink">{{data.item.order_number}}</span>
             </template>
            <template slot="gofix_table:planned_date" slot-scope="data">
                {{data.item.planned_date | formatDatebyMoment(null,"DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:expiry_date" slot-scope="data">
                {{data.item.expiry_date | formatDatebyMoment(null,"DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:checklist_name" slot-scope="data">
                <span v-if="!data.item.checklist_name">N/A</span>
                <span class="checklistLink" @click="goToChecklist(data.item)" v-else> {{ data.item.checklist_name }} </span>
            </template>
            <template slot="gofix_table:work_description" slot-scope="data">
                {{ data.item.work_description != null && data.item.work_description.length > 60 ? data.item.work_description.substring(0,60)+"..." : data.item.work_description }}
            </template>
            <template slot="gofix_table:recurring_mode" slot-scope="data">
                {{ data.item.frequency ? data.item.frequency :  "N/A"}}
            </template>
            <template slot="gofix_table:equipment_group_name" slot-scope="data">
                {{data.item.equipment_group_name ? data.item.equipment_group_name : "N/A"}}
            </template>
            <template slot="gofix_table:equipment_name" slot-scope="data">
                {{data.item.equipment_name ? data.item.equipment_name : "N/A"}}
            </template>
            <!--  -->
            <template slot="gofix_table:actions" slot-scope="data" v-if="
                data.item.order_id != null || 
                ( data.item.job_status === 'Expired' && job_status == 'Expired' && data.item.maintenance.allow_job_rescheduled.includes('Expired') == false) || 
                ( data.item.job_status === 'Expired' && job_status != 'Expired')
            ">
                <b-form-checkbox disabled></b-form-checkbox>
            </template>
            <template slot="gofix_table:verified_at" slot-scope="data">
                {{data.item.verified_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:start_at" slot-scope="data">
                {{data.item.start_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
            <template slot="gofix_table:completed_at" slot-scope="data">
                {{data.item.completed_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
            </template>
        </gofix-default-table>
        <!--Modals-->
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="assign to" hide-footer :centered="true" v-model="modals.assign.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown label="Choose FM Team" vLabel="group_name"
                            :options="fm_group_options" 
                            v-model="modals.assign.team_in_charge"
                             @change="FMTeamChange"
                            >
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Choose FM Staff"
                            vLabel="user_name"
                            v-model="modals.assign.staff_in_charge"
                            :options="fm_staff_options"
                            @search="getFMStaff" 
                            v-bind:class="{'run-loading small-loading':modals.assign.loading_fm_staff}"
                            >
                        <template #gofixInput:dropdown:option="{ user_name, role_name }">
                                {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                        </template>
                        <template #gofixInput:dropdown:selected-option="{ user_name, role_name }">
                            {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                        </template>
                    </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-supplier
                            label="Choose Supplier"
                            :contract-id="modals.assign.contract_id"
                            :required="true"
                            v-model="modals.assign.supplierAssign">
                        </gofix-form-supplier>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <b-form-checkbox v-model="modals.assign.generate_order">Generate Preventive Work Order</b-form-checkbox>
                    </b-col>
                </b-row>

            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="assignSupplier" :loading="modals.assign.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="select date (period)" hide-footer :centered="true" v-model="modals.period.open">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.period.start_date"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input-date
                            v-model="modals.period.end_date"
                            label="End Date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="periodFilterJob" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="Reschedule" ref="modal-rescheduled" class="modal-schedule-detail" hide-footer :centered="true" id="modal-rescheduled-job" v-model="modals.rescheduled.open">
            <b-form class="formV2">
                <b-row class="content scheduleInfo">
                    <b-col md="12">
                        <gofix-form-input-date
                            v-model="modals.rescheduled.start_date"
                            :required="true"
                            label="Start Date">
                        </gofix-form-input-date>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input label="Reason" :required="true" v-model="modals.rescheduled.reason_rescheduled"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                <gofix-button @click="reScheduled" label="RESCHEDULE" :loading="modals.rescheduled.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'; //Import vueX
    import { filters } from '@/_filterVar.js'; // Import source filter
    import moment from 'moment';

    export default {
        name: 'jobs',
        components: {},
        props:["job_status"],
        data() {
            let filter = JSON.parse(JSON.stringify(filters['job_list']));
            let filter_status = true;
            if(this.job_status){
                filter.job_status.value = this.job_status;
                filter_status = false;
            }

            let dataSelect = {
                job_status: {
                    value: [
                        {value: 'Planned', text: 'Planned'},
                        {value: 'Due', text: 'Due'},
                        {value: 'Started', text: 'Started'},
                        {value: 'Completed', text: 'Completed'},
                        {value: 'Verified', text: 'Verified'},
                        {value: 'Endorsed', text: 'Endorsed'},
                        {value: 'Cancelled', text: 'Cancelled'},
                        {value: 'Expired', text: 'Expired'},
                        {value: 'End', text: 'End'},
                        {value: 'Inactive', text: 'Inactive'},
                    ],
                    value_field: 'value',
                    text_field: 'text'
                }
            }

            if(this.job_status == "Due"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'Due', text: 'Due'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            if(this.job_status == "Expired"){
                dataSelect = {
                    job_status: {
                        value: [{value: 'Expired', text: 'Expired'}],
                        value_field: 'value',
                        text_field: 'text'
                    }
                }
            }

            return {
                items:[],
                tableConfig:{
                    dataSelect: dataSelect,
                    name: 'preventive-maintenance-job-list-all',
                    controls:{
                        create: false,
                        delete: this.$checkRole(this.$accessModule.job_list, 'delete'),
                        periodFilter: true,
                        createPWO: true,
                        enable: false,
                        disable: true,
                        assign: true,
                        changeStatus: true,
                        allItems: true,
                        btnReschedule: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                },
                tableItems:[],
                modals:{
                    assign:{
                        open:false,
                        loading: false,
                        clients:[],
                        generate_order:false,
                        supplierAssign: null,
                        optionsSupplier: [],
                        tierLevel: 1,
                        ids: [],
                        tiers: [],
                        filter: null,
                        time: null,
                        contract_id: null,
                        staff_in_charge: null,
                        team_in_charge: null,
                        loading_fm_staff: false,
                        property_ids: [],
                        service_category_ids: [],
                    },
                    period: {
                        tableRequest: null,
                        open: false,
                        start_date: null,
                        end_date: null,
                    },
                    rescheduled: {
                        open: false,
                        loading: false,
                        ids: [],
                        start_date: null,
                        reason_rescheduled: null
                    }
                },
                isShowRescheduledButton:false,
                fm_staff_options: [],
                fm_group_options: [],
                timer: {
                    fm_staff: null,
                }
            }
        },
        computed: {
            ...mapGetters({
                Organizations: 'OrganizationController/Organizations',
                RequestJobList: 'JobController/RequestJobList'
            })
        },
        mounted() {

        },
        created() {
            
            this.tableConfig.controls.btnReschedule = false

            if ( this.job_status == 'Expired' ) {
                this.tableConfig.controls.btnReschedule = true
            }
        },
        methods: {
            /*Table emit ----------------------------------------------------------------------*/
            async getJobItems(val){
                this.isShowRescheduledButton = false;
                /*console.log(val);
                if(val && val.length > 0){
                    let jobArray = this.tableItems;
                    let dataFilter = [];
                    let status = true;
                    jobArray.forEach(item => {
                        val.forEach(vl => {
                            if (vl == item.id) {
                               dataFilter.push(item);
                            }
                        });
                    });
                    if(dataFilter.length > 0){
                        dataFilter.forEach(item => {
                            if(!item.maintenance.allow_job_rescheduled.includes(item.job_status)){
                                status = false;
                                return;
                            }
                        });
                        if(status){
                            this.isShowRescheduledButton = true;
                        }
                    }   
                }*/
                //console.log(dataFilter);
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(this.RequestJobList.tabJob) {
                    let router = "completed";
                    switch(this.RequestJobList.tabJob) {
                        case "Due":
                            router = "due";
                            break;
                        case "Expired":
                            router = "expired";
                            break;
                    }
                    if(this.$route.path !== `/v2/job-list/${router}`) {
                        this.$router.push(`/v2/job-list/${router}`)
                        this.tableItems = [];
                        this.tableConfig.total = 0;
                        resolve({ items: [], total: 0 });
                        return
                    };
                }
                if(this.RequestJobList.dataRequest) {
                    tableRequest.filter = this.RequestJobList.dataRequest.filter
                    tableRequest.limit = this.RequestJobList.dataRequest.limit
                    tableRequest.page = 1
                    tableRequest.sortColumn = this.RequestJobList.dataRequest.sortColumn
                    tableRequest.sortDirection = this.RequestJobList.dataRequest.sortDirection
                    this.$store.commit("JobController/setRequestJobList", { dataRequest: null, tabJob: null });
                }
                //console.log(request, "request")
                await this.$store.dispatch("JobController/getJobItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the job list", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids, filter, resolve, reject } = await callback();
                this.$store.dispatch("JobController/deleteRunsheet", { ids: ids })
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'job_list'))
                }).catch(err => {
                    reject(err);
                });
            },
            async createPWO(callback){
                const { ids,filter, resolve,reject } = await callback();
                /*check: jobs are not assigned or assign not same contractor or jobs not same contract*/
                let jobs = this.tableItems.filter(item => ids.includes(item.id))
                let supplier_id = jobs[0].supplier_id;
                let contract_id = jobs[0].contract_id;
                let flag = jobs.some(item => item.supplier_id === 0 || item.supplier_id == null || item.supplier_id !== supplier_id || item.contract_id !== contract_id)
                if(flag) {
                    this.$alertNotification("Please assign jobs or select jobs with the same contractor before create PWO!", "primary");
                    resolve();
                    return;
                }

                this.$store.dispatch("OrderController/createOrderRunSheet", {
                    runsheet_ids: ids,
                    filter: filter ? JSON.stringify(filter) : null
                }).then(result => {
                    resolve();
                    return this.$alertNotification(this.$notificationV2('adding', 'order'));
                })
                .catch(error => {
                    reject();
                    return this.$alertNotification("Create Order failed. Line Items empty!", "danger");
                })
            },
            async disableItem(ids){
                this.$store.dispatch("JobController/changeJobStatus", {
                    ids: ids,
                    job_status: 'Expired',
                }).then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    return this.$alertNotification(this.$notificationV2('editing', 'job_list'));
                })
                .catch(err => {
                    return this.$alertNotification("Can't update job status", "danger");
                })
            },
            async assignItems(ids,filter){
                this.modals.assign.ids = ids;
                this.modals.assign.filter = filter;
                this.modals.assign.open = true;
                let firstSelectedItem = this.tableItems.find(element => ids.indexOf(element.id));
                this.modals.assign.contract_id = firstSelectedItem ? firstSelectedItem.client_contract_id : null;
                this.modals.assign.tierLevel = 1;
                var property_ids=[];
                var service_category_ids=[];
               
                let jobs = this.tableItems.filter(item => ids.includes(item.id));
                const jobFirst = jobs[0];
                var isSameSupplier = true;
                var isSameFMTeam = true;
                var isSameFMStaff = true;
                jobs.forEach(item=>{
                    property_ids.push(item.location_id);
                    service_category_ids.push(item.service_category_id);
                    if(isSameSupplier && item.supplier_id !== jobFirst.supplier_id) isSameSupplier = false
                    if(isSameFMTeam && item.team_in_charge_id !== jobFirst.team_in_charge_id) isSameFMTeam = false
                    if(isSameFMStaff && item.staff_in_charge_id !== jobFirst.staff_in_charge_id) isSameFMStaff = false
                });
                
                // Supplier
                this.modals.assign.supplierAssign = null;
                if(isSameSupplier && jobFirst.supplier_id) {
                    this.modals.assign.supplierAssign = {
                        id: jobFirst.supplier_id,
                        name: jobFirst.supplier,
                    }
                }

                // FM Team
                this.modals.assign.team_in_charge = null;
                if(isSameFMTeam && jobFirst.team_in_charge_id) {
                    this.modals.assign.team_in_charge = {
                        id: jobFirst.team_in_charge_id,
                        group_name: jobFirst.team_in_charge_name,
                    }
                }

                // FM Staff
                this.modals.assign.staff_in_charge = null;
                if(isSameFMStaff && jobFirst.staff_in_charge_id) {
                    this.modals.assign.staff_in_charge = {
                        id: jobFirst.staff_in_charge_id,
                        user_name: jobFirst.staff_in_charge_name,
                    }
                }

                this.modals.assign.property_ids = property_ids;
                this.modals.assign.service_category_ids = service_category_ids;
                this.getSupplier();
                this.getFMTeam();
                this.getFMStaff();
            },
            async editStatusItem(callback){
                const { ids, status, filter, resolve, reject } = await callback();
                this.$store.dispatch("JobController/changeJobStatus", {
                    ids: ids,
                    job_status: status,
                    filter: filter
                }).then(response => {
                    resolve();
                    var notificationText = '';
                    var id = '';
                    if ( status === 'Started' ) {
                        if( response.fail.length > 0 ) {
                            notificationText = 'there are '+  response.started.length +' job changed status to Started and '+ response.fail.length + " no permission to change status is Started";
                        }
                    }
                    if( status === 'Completed') {
                        notificationText = 'there are '+  response.completed.length +' job changed status to Completed and '+ response.fail.length + " no permission to change status is Completed" 
                    }
                    return this.$alertNotification(notificationText);
                })
                .catch(err => {
                    reject(err);
                    return this.$alertNotification("Can't update job status", "danger");
                })
            },
            /*End table emit ------------------------------------------------------------*/
            searchSupplier(search,loading){
                this.clients = []
                loading(true);
                if (this.modals.assign.timer) {
                    clearTimeout(this.modals.assign.timer);
                    this.modals.assign.timer = null;
                }
                this.modals.assign.timer = setTimeout(() => {
                    this.$store.dispatch('OrganizationController/searchItemsInUser', {
                        filter: {
                            name: search,
                            is_supplier:true
                        },
                        limit: 1000
                    })
                        .then(response => {
                            this.modals.assign.clients = response.data.data.items
                            loading(false)
                        })
                        .catch(err => {
                            loading(false)
                        })
                }, 500);
            },
            assignSupplier(){
                if (this.modals.assign.supplierAssign == null && !this.modals.assign.staff_in_charge  && !this.modals.assign.team_in_charge) {
                    return this.$alertNotification("Please select a supplier or FM team or FM staff!", "primary");
                }

                this.modals.assign.loading = true;
                this.$store.dispatch("JobController/assignRunsheetSupplier", {
                    ids: this.modals.assign.ids,
                    supplier: this.modals.assign.supplierAssign,
                    generate_order: this.modals.assign.generate_order,
                    filter: this.modals.assign.filter,
                    staff_in_charge_id: this.modals.assign.staff_in_charge ? this.modals.assign.staff_in_charge.user_id : null,
                    staff_in_charge_name: this.modals.assign.staff_in_charge ? this.modals.assign.staff_in_charge.user_name : null,
                    team_in_charge_id: this.modals.assign.team_in_charge ? this.modals.assign.team_in_charge.id : null,
                    team_in_charge_name: this.modals.assign.team_in_charge ? this.modals.assign.team_in_charge.group_name : null,
                }).then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.modals.assign.supplierAssign = null;
                    this.modals.assign.generate_order = false;
                    this.modals.assign.open = false;
                    this.modals.assign.loading = false;
                    if (response.data.data.code === 200) {
                        return this.$alertNotification(this.$notificationV2("editing", "job_list"));
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.modals.assign.loading = false;
                    if(this.modals.assign.generate_order) {
                        return this.$alertNotification("Create Order failed. Line Items empty!", "danger");
                    }
                })
            },
            goToChecklist(item) {
                this.$store.commit("JobController/setItem", item);
                this.$store.commit("JobController/setRequestJobList", {
                    dataRequest: this.$refs.gofixTable.tableRequest,
                    tabJob: this.job_status
                });
                let routeData = this.$router.resolve({
                    name: 'job-checklist',
                    params: { id: item.id }
                })
                window.open(routeData.href, '_blank');
            },
            gotoOrderNumber(item) {
                if(item.orders){
                    this.$router.push(`/v2/orders/${item.orders.id}`);
                }
            },
            getSupplier(){
                this.$store.dispatch("MiscExpensesController/getRelateSupplier",{
                    contract_id:this.modals.assign.contract_id,
                    filter:null
                }).then(response => {
                    this.modals.assign.tiers = response;
                    if(response.tier_1){
                        this.modals.assign.optionsSupplier = response.tier_1;
                        this.modals.assign.tierLevel = 1;
                    }else if(response.tier_2){
                        this.modals.assign.optionsSupplier = response.tier_2;
                        this.modals.assign.tierLevel = 2;
                    }else if(response.tier_3){
                        this.modals.assign.optionsSupplier = response.tier_3;
                        this.modals.assign.tierLevel = 3;
                    }
                })
                .catch( err => {
                    console.log(err)
                })
            },
            showMoreSupplier(){
                switch (this.modals.assign.tierLevel) {
                    case 1:
                        this.modals.assign.optionsSupplier = this.modals.assign.optionsSupplier.concat(this.modals.assign.tiers.tier_2);
                        this.modals.assign.tierLevel = 2;
                        break;
                    case 2:
                        this.modals.assign.optionsSupplier = this.modals.assign.optionsSupplier.concat(this.modals.assign.tiers.tier_3);
                        this.modals.assign.tierLevel = 3;
                        break;
                }
            },
            periodFilterJob() {
                if(!this.modals.period.start_date) {
                    return this.$alertNotification("Start date is required", "danger");
                }

                if(!this.modals.period.end_date) {
                    return this.$alertNotification("End date is required", "danger");
                }

                if(moment(this.modals.period.start_date).isAfter(this.modals.period.end_date)) {
                    return this.$alertNotification("Start date must be greater than end date", "danger");
                }

                this.modals.period.tableRequest.planned_date.function = "<>";
                this.modals.period.tableRequest.planned_date.value = [ moment(new Date(this.modals.period.start_date)).format('YYYY-MM-DD'), moment(new Date(this.modals.period.end_date)).format('YYYY-MM-DD') ];

                this.modals.period.open = false;
                this.$refs.gofixTable.reloadTableKeepFilter();
            },

            getFMTeam() {
                this.fm_group_options = [];
                this.$store.dispatch("UserGroupController/getItems", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.modals.assign.contract_id
                        }
                    })
                    .then(response => {
                        this.fm_group_options = response.items;
                    })
                    .catch(err => {
                        this.fm_group_options = [];
                    })
            },
            
            getFMStaff(search) {
                this.fm_staff_options = [];
                this.modals.assign.loading_fm_staff = true;
                if (this.timer.fm_staff) {
                    clearTimeout(this.timer.fm_staff);
                    this.timer.fm_staff = null;
                }
                this.timer.fm_staff = setTimeout(() => {
                    var params = {
                            contract_id: this.modals.assign.contract_id,
                            property_ids: this.modals.assign.property_ids ? this.modals.assign.property_ids : null,
                            service_category_ids: this.modals.assign.service_category_ids ? this.modals.assign.service_category_ids : null,
                            section_name: ["Preventive Maintenance"],
                            module_name: ["Job List"],
                            filter: {
                                name: search || null
                            }
                        };
                    if(this.modals.assign.team_in_charge){
                        params.group_id = this.modals.assign.team_in_charge.id;
                    }
                    this.$store.dispatch("v2UserController/getAccessRunsheetFmUsers", params)
                        .then(response => {
                            this.fm_staff_options = response.items;
                            this.modals.assign.loading_fm_staff = false;
                        })
                        .catch(err => {
                            this.modals.assign.loading_fm_staff = false
                        })
                }, 500);
            },
            FMTeamChange(id){
                this.modals.assign.staff_in_charge = null;
                this.fm_staff_options = [];
                this.getFMStaff();
            },
            /*--- Export File ---*/
            exportItems(tableRequest) {
            //    if(this.RequestJobList.tabJob) {
            //         let router = "completed";
            //         switch(this.RequestJobList.tabJob) {
            //             case "Due":
            //                 router = "due";
            //                 break;
            //             case "Expired":
            //                 router = "expired";
            //                 break;
            //         }
            //     }
                if(this.RequestJobList.dataRequest) {
                    tableRequest.filter = this.RequestJobList.dataRequest.filter;
                    tableRequest.limit = -1;
                    tableRequest.sortColumn = this.RequestJobList.dataRequest.sortColumn;
                    tableRequest.sortDirection = this.RequestJobList.dataRequest.sortDirection;
                }

                this.$store.dispatch( 'JobController/export', tableRequest)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'JobList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
                
            },
            async btnReschedule(callback) {
                const { ids, resolve, reject } = await callback();

                if ( !ids ) {
                    return this.$alertNotification('Please select a item', 'danger');
                }

                this.modals.rescheduled.ids = ids
                this.modals.rescheduled.open = true
                this.modals.rescheduled.start_date = null
                this.modals.rescheduled.reason_rescheduled = null
            },
            async reScheduled(){
                if(!this.modals.rescheduled.ids) {
                    return this.$alertNotification('Please select a item', 'danger');
                }
                if(!this.modals.rescheduled.start_date) {
                    return this.$alertNotification('Start Date is required', 'danger');
                }
                if(!this.modals.rescheduled.reason_rescheduled) {
                    return this.$alertNotification('Reason is required', 'danger');
                }
                
                this.modals.rescheduled.loading = true

                let start_date = moment(new Date(this.modals.rescheduled.start_date)).format(
                    'YYYY-MM-DD'
                );

                let data = {
                    ids: this.modals.rescheduled.ids,
                    start_date: start_date,
                    reason_rescheduled: this.modals.rescheduled.reason_rescheduled
                };

                await this.$store
                    .dispatch("JobController/reScheduledRunsheet", data)
                    .then((result) => {
                        this.modals.rescheduled.loading = false
                        this.modals.rescheduled.open = false

                        this.$alertNotification('Reschedule success!');
                        this.$refs['modal-rescheduled'].hide();

                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch((err) => {
                        this.modals.rescheduled.loading = false
                        this.modals.rescheduled.open = false

                        this.$refs['modal-rescheduled'].hide();
                        
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }

                        this.$refs.gofixTable.reloadTableKeepFilter();
                });
            },
        }
    }
</script>
